import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const HeaderContainer = styled(Box)({
  display: 'flex',
  gap: 8,
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8
})

export const LabelContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '90%'
})

export const LabelTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
  hyphens: 'auto'
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  padding: 4,
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const StyledInfoIcon = styled(InfoOutlinedIcon)(({theme}) => ({
  fontSize: 18,
  color: theme.palette.text.secondary
}))

export const RemoveIconButton = styled(IconButton)(({theme}) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))
